import { useEffect, useState } from 'react';
import { SunkenBox } from '@ewf/components/SunkenBox';
import walletConnectLogo from '@ewf/assets/logos/wallet-connect.svg';
import ledgerLogo from '@ewf/assets/logos/ledger.svg';
import polkadotLogo from '@ewf/assets/logos/polkadot.svg';
import { WalletButton } from './WalletButton';
import { MARKETPLACE_CHAINS } from '@shared/types/enums';
import { isElectron } from '@shared/utils/is-electron';

export const WalletSelector = ({
  selectedWallet,
  setSelectedWallet,
  network,
}: Props): JSX.Element => {
  const selectWalletConnect = () => setSelectedWallet('wallet-connect');
  const selectLedger = () => setSelectedWallet('ledger');
  const selectPolkadot = () => setSelectedWallet('polkadot');
  const [hasPolkadotExtension, setHasPolkadotExtension] = useState(false);

  useEffect(() => {
    if ((window as any).injectedWeb3?.['polkadot-js'] && !isElectron()) {
      setHasPolkadotExtension(true);
    }
  }, []);

  return (
    <div className="rounded-lg p-6 bg-popup-gradient">
      <SunkenBox className="mb-8 text-center">
        <p className="mb-1 text-lg font-bold text-white">Connect to {network} Account</p>
        <p className="text-md text-font-subtle">Select your preferred wallet</p>
      </SunkenBox>
      <div className="grid grid-cols-2 gap-6">
        <WalletButton
          isSelected={selectedWallet === 'wallet-connect'}
          onSelect={selectWalletConnect}
        >
          <img src={walletConnectLogo} width={56} height={56} alt="Wallet connect" />
          <p>Wallet Connect</p>
        </WalletButton>
        <WalletButton
          isSelected={selectedWallet === 'ledger'}
          onSelect={selectLedger}
        >
          <img src={ledgerLogo} width={56} height={56} alt="Ledger" />
          <p>Ledger</p>
        </WalletButton>
        { !isElectron() && hasPolkadotExtension && network === MARKETPLACE_CHAINS.EWX && (
          <WalletButton
            isSelected={selectedWallet === 'polkadot'}
            onSelect={selectPolkadot}
          >
            <img src={polkadotLogo} width={56} height={56} alt="Polkadot" />
            <p>Polkadot.js</p>
          </WalletButton>
        )}
      </div>
    </div>
  );
};

export type Wallet = 'wallet-connect' | 'ledger' | 'polkadot';
interface Props {
  selectedWallet: Wallet;
  setSelectedWallet: (wallet: Wallet) => void;
  network: MARKETPLACE_CHAINS;
}
